// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"e618f05e","386":"fb4be1af","749":"f8a8952f"}[chunkId] + ".chunk.js";
};